import { SELF_CLOSE_IFRAME } from '../../../../front/src/services/communication/types';
import type { AuthResponse } from '../../../../front/src/types/auth';
import { getGraphLogin } from '../../components/auth/LoadGraphLogin';
import { saveNativeTokens } from './nativeTokenStorage';

export const finalizeNativeLogin = async (
  websiteKey: string,
  locale: string,
  authTokens: AuthResponse,
) => {
  // Mirror the freshly issued tokens into Capacitor storage so the native shell can revive them later.
  await saveNativeTokens(websiteKey, authTokens);
  console.log('✅ Tokens persisted natively');

  // Retrieve the GraphLogin instance
  const graphLogin = getGraphLogin(websiteKey, locale);
  console.log('✅ GraphLogin instance retrieved');

  // Wait until GraphLogin is ready
  await graphLogin.isReady;
  console.log('✅ GraphLogin ready');

  // Create the authResponse object as expected by GraphLogin
  const authResponse = {
    token: authTokens.token,
    refreshToken: authTokens.refreshToken,
  };

  console.log('✅ Auth response created', authResponse);

  // Use the GraphLogin method to save the token
  // This method will automatically trigger all subscriptions,
  // update the token in storage, and notify all listeners
  // Note: The refreshToken is already saved by finalizeNativeLogin() in GraphLogin,
  // but we still call saveToken() to trigger subscriptions and notify listeners
  console.log('✅ Saving token via GraphLogin.saveToken...');
  await graphLogin.saveToken(authResponse);
  console.log('✅ Token saved and subscriptions triggered');

  // Simulate the SELF_CLOSE_IFRAME message just like in the normal web flow of GraphLogin
  // The listener in GCContainer.open() will catch this message and automatically close the modal
  console.log('🔄 Sending SELF_CLOSE_IFRAME message to trigger modal close...');
  window.postMessage(
    {
      type: SELF_CLOSE_IFRAME,
      withToken: true,
    },
    window.location.origin,
  );
  console.log('✅ SELF_CLOSE_IFRAME message sent, modal should close automatically');
};
